export enum PageButtonType {
    DANGER,
    CONFIRM,
    NEUTRAL,
    PRIMARY,
    OUTLINE_PRIMARY,
    DARK,
    INFO,
    WARNING
}

export enum PageWidth {
    PP,
    P,
    M,
    G,
    GG
}

export type PageButton = {
    type: PageButtonType,
    label: string,
    action: () => void,
    disabled?: boolean
};
